import script from "./esEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./esEditor.vue?vue&type=script&setup=true&lang=ts"

import "./esEditor.vue?vue&type=style&index=0&id=18cdcc63&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18cdcc63"]])

export default __exports__